import { Interface } from "@ethersproject/abi";
import { useContractCall, useEthers } from "@usedapp/core";
import { useMemo } from "react";
import TokenControllerAbi from "../../abis/TokenController.json";
import { useTokenControllerAddress } from "./useAddress";

const TOKEN_CONTROLLER_INTERFACE = new Interface(TokenControllerAbi);

export const useAccountBorrow = (): number => {
  const tokenControllerAddress = useTokenControllerAddress();
  const { account } = useEthers();
  const [borrowAmount] =
    useContractCall(
      tokenControllerAddress &&
        account && {
          abi: TOKEN_CONTROLLER_INTERFACE,
          address: tokenControllerAddress,
          method: "getAccountTotalBorrows",
          args: [account],
        }
    ) ?? [];

  return useMemo(() => {
    return +(borrowAmount?.toString() || "0");
  }, [borrowAmount]);
};
